import { makeStyles } from "tss-react/mui";

export const AXIS_STYLE = {
  axis: { stroke: "#C9CBCD", strokeWidth: 0.5 },
  grid: { stroke: "#C9CBCD", strokeWidth: 0.5, strokeDasharray: "2 2" },
  tickLabels: {
    fill: "#595959",
    fontWeight: 500,
    fontSize: "9px",
    fontFamily: "Montserrat",
  },
};

export const RETRO_AXIS_STYLE = {
  axis: { stroke: "#C9CBCD", strokeWidth: 0.5 },
  tickLabels: {
    fill: "white",
    fontWeight: 500,
    fontSize: "9px",
    fontFamily: "Montserrat",
  },
};

export const CHART_PADDING = {
  left: 70,
  right: 15,
  top: 15,
  bottom: 40,
};

export const INVESTMENTS_CHART_PADDING = {
  left: 60,
  right: 30,
  top: -30,
  bottom: 20,
};

export const COLOR_SCHEME = ["#2E8267", "#F2BB4F", "#D32F2F"];

export const useChartStyles = makeStyles()((theme) => ({
  bordered: {
    borderRadius: "20px",
    border: `0.703px solid ${theme.palette.charts.primary}`,
  },
  wrapper: {
    borderRadius: "20px",
    border: theme.palette.charts.border,
    flex: 1,
    justifyContent: "center",
  },
}));

export const valuePlaceholder = [0, 500, 1000, 1500, 2000, 2500];
